import account from "src/bloc/account";
import update from "src/bloc/update";

export default {
  account,
  update
};
